const removedLocale = undefined;
export default removedLocale;
